import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import React from 'react';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const SectionAccordians = ({ children, header, isDefaultExpanded }) => {
  return (
    <Box>
      <Accordion
        sx={{
          border: '1px solid #e2e2e2',
          boxShadow: '0px 5px 8px rgba(0, 0, 0, 0.1)', // subtle shadow
          borderRadius: '8px',
          backgroundColor: '#fff',
          '&::before': {
            display: 'none', // removes default MUI divider line
          },
          '&.Mui-expanded': {
            margin: 0,
          },
          fontSize: '0.85rem',
        }}
        defaultExpanded={isDefaultExpanded ? isDefaultExpanded : false}>
        <AccordionSummary
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="requiredCertificationInformation">
          <Typography sx={{ fontSize: '0.9rem' }} component="span">
            {header}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default SectionAccordians;
